import store from "@/store";
import requestService from "@/service/requestService";
import { SocketControllers } from "@/service/SocketControllers";
import { ExtendsImageInspectVO } from "@/model/ExtendsImage";
import { Utils } from "@/service/util";

// インスタンス生成
const utilsInstance = new Utils();

export class ExtendsImageService {
  reqService: requestService;
  sktControll: SocketControllers;
  uketsukeExtendsId: number;
  socketCallback: (updatedList: ExtendsImageInspectVO[]) => void;
  constructor() {
    this.reqService = new requestService();
    this.uketsukeExtendsId = store.getters["ReservationDetail/uketsukeExtendsId"];
  }

  // 点検データの全量を取得する
  async getExtendsImageInspectList() {
    const res: any = await this.reqService.getExtendsImageInspect(this.uketsukeExtendsId);
    if (res && res.seibi) {
      return res.seibi;
    }
    return null;
  }
  // 点検データの全量のinspectIdのマップを取得する
  async getExtendsImageInspectMap() {
    const extendsImageInspectList = await this.getExtendsImageInspectList() as ExtendsImageInspectVO[];
    if (!extendsImageInspectList) {
      return null;
    }
    const map: { [sknUketsukeInspectId: number]: ExtendsImageInspectVO } = {};
    for (const inspect of extendsImageInspectList) {
      map[inspect.sknUketsukeInspectId!] = inspect;
    }
    return map;
  }
  // 点検データの1件分を取得する
  async getExtendsImageInspectByInspectId(sknUketsukeInspectId: number) {
    const res: any = await this.reqService.getExtendsImageInspect(this.uketsukeExtendsId, sknUketsukeInspectId);
    return res || null;
  }

  // ソケット:35画像登録の共通部分
  // ※引数sktControllは、呼び元画面でソケット接続をしている場合に渡して、同じインスタンスを使い回す（その場合はextendsImageService.destroy()も呼び出し不要）
  connectSocket(
    callback: (updatedList: ExtendsImageInspectVO[]) => void,
    sktControll: SocketControllers | null = null
  ) {
    if (this.sktControll) {
      return;
    }
    if (sktControll) {
      this.sktControll = sktControll;
    } else {
      this.sktControll = new SocketControllers();
    }
    this.socketCallback = callback;
    this.sktControll.socketEntry("extendsImageSubscription", this._socketCallback.bind(this));
    this.sktControll.connectSocket();
  }
  private _socketCallback(frame: any) {
    const updatedList: ExtendsImageInspectVO[] = utilsInstance.getWSData(frame);
    if (!updatedList || !updatedList[0]) {
      return;
    }
    this.socketCallback(updatedList);
  }
  destroy() {
    if (this.sktControll) {
      this.sktControll.freeSocketResources();
    }
  }
}
